export const SET = 'SET'
export const RESET = 'RESET'

export default {
  SET,
  RESET,
}

export const noPersist = []
